const SetFilterFieldValues = (preset, currentFilters) => {
    let newFilters = [];
    for (const filter of currentFilters) {
        let newFilter = {...filter};
        const presetValue = preset.Fields.filter((flt) => flt.Key === filter.Key);
        if (presetValue.length > 0) {
            newFilter.values = presetValue[0] !== undefined ? presetValue[0].Values : [];
        }
        newFilters.push(newFilter);
    }

    return newFilters;
}

export default SetFilterFieldValues;